import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { AppVersionService } from "@main/app-versioning/api/app-version.service";
import { Injectable } from "@angular/core";
import { tap } from "rxjs/operators";
import { Observable } from "rxjs";

@Injectable()
export class AppVersionInterceptor implements HttpInterceptor {
    constructor(private appVersionService: AppVersionService) {
    }

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(tap(event => {
            if (event instanceof HttpResponse) {
                const version: string = event.headers.get(AppVersionService.ResponseHeaderItemKey);
                this.appVersionService.compareVersion(version);
            }
        }));
    }
}